import React   from 'react';
import connect from 'react-redux/es/connect/connect';

class UserGate extends React.Component {
    render() {
        return (
            <React.Fragment>
                {!this.props.user &&
                 <div>loading...</div>
                }
                {this.props.user && this.props.children}
            </React.Fragment>
        );
    }
}

export default connect(state => ({
    user: state.oidc.user
}))(UserGate);



// WEBPACK FOOTER //
// /src/components/framework/UserGate.js